import React, { useContext } from "react";
import "./_sidebar.scss";

import Heading from "./../../02-molecules/heading/heading";
import Steps from "./../../02-molecules/steps/steps";
import Loader from "./../../01-atoms/loader/loader";

import { GlobalContext } from "./../../../utils/global-context";

const Sidebar = ({ heading, steps }) => {
  const {
    goBack,
    history,
    wizardTheme,
    resetWizard,
    currentStepNumber,
    totalSteps,
  } = useContext(GlobalContext) || {};

  const isVisualizationTwo = wizardTheme === "visualization_2";
  const hasHistory = Boolean(history && history.length > 0);
  const showActions = isVisualizationTwo && hasHistory;
  const progressSegments = Array.from({ length: Math.max(totalSteps ?? 1, 1) });

  return (
    <div className="wizard__sidebar">
      {isVisualizationTwo && (
        <div className="wizard__progress">
          <div className="wizard__progress-track">
            {progressSegments.map((segment, index) => {
              let state = "is-pending";
              if (index < currentStepNumber - 1) state = "is-done";
              if (index === currentStepNumber - 1) state = "is-current";

              return (
                <span
                  key={index}
                  className={`wizard__progress-segment ${state}`}
                />
              );
            })}
          </div>
          <span className="wizard__progress-text">
            {currentStepNumber} de {progressSegments.length}
          </span>
        </div>
      )}

      <Heading title={heading.title} description={heading.description} />

      {steps ? <Steps steps={steps} /> : <Loader />}

      {showActions && (
        <div className="wizard__actions">
          <button className="wizard__back-button" onClick={goBack}>
            <span aria-hidden="true">‹</span>
            Atrás
          </button>

          <button className="wizard__reset-button" onClick={resetWizard}>
            <span aria-hidden="true">↻</span>
            Reiniciar
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
